import { omit } from "lodash";

export function deepSet<D, T>(data: D, path: string, value: T) {
    const pathPartsRegex = /^.*\[.*\]$/.test(path) ? /[[\]]/ : /[.[\]]/;
    const pathParts = path.split(pathPartsRegex).filter(p => !!p);
    try {
        return recursiveSet(data, pathParts, value);
    }
    catch {
        throw new Error(`Invalid path: "${path}"`);
    }
}

function recursiveSet<O, T>(obj: O, pathParts: string[], value: T): O {
    if (!pathParts.length) {
        return value as any;
    }

    const [ pathPart, ...remainingPathParts ] = pathParts;
    if (Array.isArray(obj)) {
        const arrayIndex = parseInt(pathPart, 10);
        const clone = [ ...(obj as T[]) ];
        const subObj = clone[arrayIndex];
        clone.splice(arrayIndex, 1, recursiveSet(subObj, remainingPathParts, value));
        return clone as any;
    }
    else {
        const subObj = (obj as any)[pathPart];
        const recursiveValue = recursiveSet(subObj, remainingPathParts, value);
        if (recursiveValue === undefined) {
            return omit(obj as any, pathPart) as O;
        }
        return {
            ...obj,
            [pathPart]: recursiveValue,
        };
    }
}
